"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._testHook = void 0;
require("whatwg-fetch");
// Default location context for autocomplete results. This is a location in Dexter, KS
// located in the middle of the country.
var DEFAULT_CENTROID = {
  lat: 37.179411,
  lon: -96.715912
};

// API will throw error if result count is greater than 12
var MAX_RESULT_COUNT = 12;
var convertServerResponseJSONToFetcherResponse = function convertServerResponseJSONToFetcherResponse(serverResponseJSON) {
  if (serverResponseJSON.results) {
    return serverResponseJSON.results.map(function (data) {
      return {
        displayName: data.display,
        category: data.resultType.toUpperCase(),
        subCategory: null,
        data: data.metaData
      };
    });
  }
  return [];
};
var ZillowAutocompleteFetcher = /*#__PURE__*/function () {
  // constructor
  // argument: baseURL - a String that is the base URL for zillow autocomplete service
  // argument: centroid - a Javascript object representing the location context for autocomplete
  //    format: centroid = { lat: [number], lon: [number] }
  function ZillowAutocompleteFetcher(baseURL, centroid) {
    this.baseURL = baseURL;
    this.centroid = centroid || DEFAULT_CENTROID;
  }
  var _proto = ZillowAutocompleteFetcher.prototype;
  _proto.constructURL = function constructURL(prefix, centroid, config) {
    var _config$resultTypes;
    var curCentroid = centroid || this.centroid;
    var url = this.baseURL + "suggestions?";
    var params = [];
    params.push("q=" + encodeURIComponent(prefix));
    params.push("&userLat=" + curCentroid.lat);
    params.push("&userLon=" + curCentroid.lon);
    if (config !== null && config !== void 0 && (_config$resultTypes = config.resultTypes) !== null && _config$resultTypes !== void 0 && _config$resultTypes.length) {
      params.push("&resultTypes=" + config.resultTypes.join(','));
    }
    if (config !== null && config !== void 0 && config.fetchMaxResults || config !== null && config !== void 0 && config.resultCount) {
      var resultCount = config !== null && config !== void 0 && config.fetchMaxResults ? MAX_RESULT_COUNT : config === null || config === void 0 ? void 0 : config.resultCount;
      params.push("&resultCount=" + resultCount);
    }
    if (config !== null && config !== void 0 && config.abKey) {
      params.push("&abKey=" + config.abKey);
    }
    if (config !== null && config !== void 0 && config.clientId) {
      params.push("&clientId=" + config.clientId);
    }
    return "" + url + params.join('');
  }

  // fetchResults
  // argument: prefix - a String to send to the autocomplete service
  // argument: centroid - override the centroid from the constructor
  // argument: config - other optional arguments:
  //              resultTypes: array of strings. See service documentation for allowed values
  //              fetchMaxResults: boolean - true will fetch max result count (12), otherwise will fetch the default of 5
  //              abKey: string - user guid used for ab service
  //              clientId: string - identifies caller of autocomplete service for tracking
  // returns a Promise that resolves to an array of autocomplete entries
  ;
  _proto.fetchResults = function fetchResults(prefix, centroid, config) {
    if (config === void 0) {
      config = {};
    }
    return fetch(this.constructURL(prefix, centroid, config)).then(function (response) {
      return response.json();
    }).then(function (json) {
      return convertServerResponseJSONToFetcherResponse(json);
    });
  };
  return ZillowAutocompleteFetcher;
}();
var _testHook = {
  convertServerResponseJSONToFetcherResponse: convertServerResponseJSONToFetcherResponse
};
exports._testHook = _testHook;
var _default = ZillowAutocompleteFetcher;
exports.default = _default;